import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from './ui/button';
import { useAlerts } from './Alerts';

/**
 * Operational alerts bell — distinct from NotificationBell (which surfaces
 * team activity log entries). This one counts pending tasks the team
 * needs to act on (driver shares, hotel check-ins, missing tour data,
 * vendor payments due). Polls /api/pollen/alerts every 60s.
 */
const AlertsBell = () => {
  const navigate = useNavigate();
  const { counts } = useAlerts(60_000);
  const n = counts.total || 0;
  const urgent = counts.urgent || 0;
  return (
    <Button
      variant="ghost"
      size="sm"
      className="relative p-2 h-9 w-9"
      onClick={() => navigate('/pollen-dots/alerts')}
      data-testid="alerts-bell"
      aria-label="Operational alerts"
      title={n ? `${n} alert${n === 1 ? '' : 's'} pending` : 'No alerts'}
    >
      <ShieldAlert className={`w-4 h-4 ${urgent ? 'text-rose-600' : ''}`} />
      {n > 0 && (
        <span
          className={`absolute -top-0.5 -right-0.5 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center ${urgent ? 'bg-rose-600' : 'bg-amber-500'}`}
          data-testid="alerts-bell-count"
        >
          {n > 99 ? '99+' : n}
        </span>
      )}
    </Button>
  );
};

export default AlertsBell;
